import { useAuthStore } from '@shared/stores/authStore';
import { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    redirectPath?: string;
}

const ProtectedRoute = ({
    redirectPath = '/login',
}: ProtectedRouteProps): ReactNode => {
    const token = useAuthStore((state) => state.token);
    const location = useLocation();

    if (!token) {
        // Guardar la URL actual para redirigir después del login
        const currentPath = location.pathname + location.search;
        const loginUrl = `${redirectPath}?redirect=${encodeURIComponent(currentPath)}`;
        return <Navigate to={loginUrl} replace />;
    }
    return <Outlet />;
};

export default ProtectedRoute;

